import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import { Link, useNavigate } from "react-router-dom";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate(); // хук для навигации
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Ошибка входа");
        return;
      }

      // Сохраняем токен и роль
      login(data.token, data.role);

      // перенаправление по роли
      if (data.role === "patient") {
        navigate("/cabinet");
      } else if (data.role === "operator") {
        navigate("/staff");
      } else if (data.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/login"); // fallback на логин
      }
    } catch (err) {
      console.error("Ошибка запроса:", err);
      setError("Ошибка сети");
    }
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Вход в личный кабинет
      </h1>

      {error && <p style={{ color: "red" }}>{error}</p>}
      <form className="login__form" onSubmit={handleSubmit}>
        <div className="login__div">
          <label className="login__label">Email:</label>
          <input
            className="field"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="login__div">
          <label className="login__label">Пароль:</label>
          <input
            className="field"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="login__button" type="submit">
          Войти
        </button>
      </form>
      <Link to="/register" className="login__content">
        Зарегистрироваться
      </Link>
    </section>
  );
}
